import { login, register as registerApi, logout as logoutApi } from '../api/auth'
import { useSubscriptionPlanStore } from "../store/subscription.store";
import { useFeatureUsageStore } from "../store/feature-usage.store";
import { useOnboardingChecklist } from "../store/onboarding-checklist.store";
import { BEACH_COMUTE_USERS } from '../storage'

const POST_ONBOARDING_REDIRECT_MAP = {
    resume: 'resumes',
    'cover-letter': 'cover-letters.index',
    networking: 'networking-tool',
    interviews: 'interview-ai',
    findJobs: 'job-board-search',
    applicationsTracking: 'job-tracker',
    na: 'home'
}

export const setAuthState = () => {
    const isAuthenticated = () => {
        return getUser() !== null
    }

    const userHaveAccessTo = (feature) => {
        return !!getUser().features?.[feature]
    }
    
    const getAfterOnboardingRedirect = () => {
        return POST_ONBOARDING_REDIRECT_MAP[getUser().options?.stuck_at]
    }
    
    const isOnboardingComplete = () => {
        return !!getUser()?.steps_completed
    }
    
    const isKajabiUser = () => {
        return getUser()?.options?.is_kajabi_user ?? false
    }

    const isEmailInDomain = (domain) => {
        return getUser()?.email?.endsWith(domain) ?? false;
    }
    
    const setUser = (user) => {
        localStorage.setItem('user', JSON.stringify(user))
    }

    const getUser = () => {
        if (localStorage.getItem('user') && localStorage.getItem('user') !== "undefined") {
            return JSON.parse(localStorage.getItem('user'))
        }
        return null;
    }

    const authenticate = ({ email, password }) => {
        return new Promise((resolve, reject) => {
            login({ email, password }).then(({ data: { data } }) => {
                setUserData(data)
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    const register = ({ first_name, last_name, email, password, password_confirmation }) => {
        return new Promise((resolve, reject) => {
            registerApi({ email, first_name, last_name, password, password_confirmation }).then(({ data: { data } }) => {
                setUserData(data)
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    const logout = () => {
        return new Promise((resolve, reject) => {
            logoutApi()
                .then(res => {
                    resolve()
                }).catch(err => {
                    reject(err)
                }).finally(() => {
                    localStorage.removeItem('user')
                })
        })
    }
    
    const setUserData = (data) => {
        const { setUserPlan } = useSubscriptionPlanStore()
        const featureUsageStore = useFeatureUsageStore()
        const onboardingChecklistStore = useOnboardingChecklist()

        setUser(data)
        setUserPlan(data?.current_plan)
        featureUsageStore.setFeatureUsage(data?.feature_usage)
        onboardingChecklistStore.setOnboardingChecklist(data)
    }

    const isBeachComuteUser = () => {
        const encode = btoa(getUser()?.email)
        return BEACH_COMUTE_USERS.includes(encode)
    }

    const isWonsultingUser = () => isEmailInDomain("@wonsulting.com");

    return {
        getUser,
        setUser,
        isAuthenticated,
        authenticate,
        register,
        logout,
        userHaveAccessTo,
        setUserData,
        isEmailInDomain,
        isKajabiUser,
        isBeachComuteUser,
        isOnboardingComplete,
        getAfterOnboardingRedirect,
        isWonsultingUser
    }
}
